const SummaryTable = ({ summary }) => {
    // filter out $0 items except "Total"
    const filteredSummary = summary.filter(
        item => item.type === 'Total' || parseFloat(item.amount) > 0
    );

    if (filteredSummary.length === 0) return null;

    return (
        <div className="overflow-x-auto">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
                Total Summary
            </h3>
            <table className="w-full">
                <thead>
                    <tr className="border-b border-gray-100">
                        <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Type
                        </th>
                        <th className="text-right py-3 px-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Amount
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                    {filteredSummary.map((item) => (
                        <tr
                            key={item.type}
                            className={item.type === 'Total'
                                ? 'border-t border-gray-200 bg-gray-50'
                                : 'hover:bg-gray-50 transition-colors'}
                        >
                            <td className={`py-3 px-2 ${item.type === 'Total' ? 'font-semibold text-gray-900' : 'font-medium text-gray-700'}`}>
                                {item.type}
                            </td>
                            <td className={`py-3 px-2 text-right ${item.type === 'Total' ? 'font-bold text-primary' : 'font-medium text-gray-900'}`}>
                                ${parseFloat(item.amount).toFixed(2)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SummaryTable;
